import VIDABOO_CONSTANTS from '../../config/consts';
import utilsService from '../utilsService';

var service = {};
const privateState = {};

service.setResetWhiteLabelContextFunc = (resetWhiteLabelContext) => {
  privateState.resetWhiteLabelContext = resetWhiteLabelContext;
};

service.resetWhiteLabelContext = () => {
  if (privateState.resetWhiteLabelContext) {
    privateState.resetWhiteLabelContext();
  }
};

service.getAgencyPhotoUrlByObjectAndPhotoType = (
  agencyPhotoDtos = [],
  objectType,
  photoType,
) => {
  if (!objectType || !photoType || !Array.isArray(agencyPhotoDtos)) return '';

  const photoDto = agencyPhotoDtos.find(
    (agencyPhotoDto) =>
      agencyPhotoDto.objectType === objectType &&
      agencyPhotoDto.photoType === photoType,
  );

  return photoDto?.photoUrl || '';
};

// Returns an object: { isAgencyWhiteLabeled, agencyName, agencyDomain, agencyWebsite, agencyContactEmail, agencyPhotoDtos,  }
service.mapResellerAgencyCtrlToWhiteLabelConfig = (
  resellerAgencyCtrl = {},
  currentPhotoDtos = [],
) => {
  const mappedData = {};

  if (!resellerAgencyCtrl) return mappedData;

  mappedData.isAgencyWhiteLabeled = !!resellerAgencyCtrl.whiteLabel;

  if (resellerAgencyCtrl.brandName)
    mappedData.agencyName = resellerAgencyCtrl.brandName;
  if (resellerAgencyCtrl.supportEmail) {
    mappedData.agencyContactEmail = resellerAgencyCtrl.supportEmail;
    mappedData.agencySupportEmail = resellerAgencyCtrl.supportEmail;
  }
  if (resellerAgencyCtrl.domain)
    mappedData.agencyDomain = resellerAgencyCtrl.domain;
  if (resellerAgencyCtrl.website)
    mappedData.agencyWebsite = resellerAgencyCtrl.website;
  if (resellerAgencyCtrl.terms)
    mappedData.agencyTerms = resellerAgencyCtrl.terms;
  if (resellerAgencyCtrl.privacyPolicy)
    mappedData.agencyPrivacyPolicy = resellerAgencyCtrl.privacyPolicy;

  const photoDtos = resellerAgencyCtrl?.photoDtos || [];
  const supportedTypes = [
    VIDABOO_CONSTANTS.PHOTO_TYPES.BACKGROUND,
    VIDABOO_CONSTANTS.PHOTO_TYPES.FAVICON,
    VIDABOO_CONSTANTS.PHOTO_TYPES.EMAIL_LOGO,
  ];

  const newPhotosFromReseller = photoDtos
    .filter(
      (photoDto) => photoDto && supportedTypes.includes(photoDto.photoType),
    )
    .map((photoDto) => ({
      objectType: VIDABOO_CONSTANTS.PHOTO_OBJECT_TYPES.RESELLERAGENCY,
      photoType: photoDto.photoType,
      photoUrl: utilsService.getPhotoManipulatedUrl(photoDto, ''),
    }));

  // Efficiently merge: clone current photos and update/add only reseller agency photos
  const mergedPhotoDtos = [...currentPhotoDtos];

  newPhotosFromReseller.forEach((newPhoto) => {
    const existingIndex = mergedPhotoDtos.findIndex(
      (photo) =>
        photo.objectType === newPhoto.objectType &&
        photo.photoType === newPhoto.photoType,
    );
    if (existingIndex !== -1) {
      mergedPhotoDtos[existingIndex] = newPhoto;
    }
    // we don't add new photos that are not in the default set, to avoid issues with unsupported types or duplicates. so no need of else block here
  });
  mappedData.agencyPhotoDtos = mergedPhotoDtos;
  return mappedData;
};

// re-export service with new method included
const whiteLabelContextService = {...service};
export default whiteLabelContextService;
